exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userincome-component{padding-left:0;padding-right:0}.userincome-component .text-gray{color:#999}.userincome-component .media-component .media:first-child{padding-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/FootPrints.scss
// module id = 638
// module chunks = 0